export default function getResource(label, vars = []) {
    const resources = {
        title: 'Votre résumé',
        birthdayGiftTitle: 'Choisissez votre cadeau d’anniversaire',
        bankRewards: `Récompenses carte de crédit : *${vars[0]} $*`,
        pointsMultiplierText: `Événement multiplicateur de points : Accumulez *${vars[0]}* points sur vos achats`,
        rougeRewardsApply: `Récompenses Rouge : Appliquer à votre achat pour profiter d’une réduction allant jusquʼà *${vars[0]}*`,
        dollarsSaved: `Vos économies ${vars[0]} en un coup d’œil`,
        SDDRougeTestFreeShipping: `En tant que membre Rouge, vous pouvez essayer *gratuitement la livraison le jour même* sur toute commande de ${vars[0]} $ ou plus`,
        rougeMemberFreeSameDayDelivery: 'En tant que membre Rouge, vous pouvez essayer *gratuitement de la livraison le jour même*!',
        freeShip: 'Vous profitez de la *livraison standard GRATUITE* sur toutes les commandes',
        rougeBadge: 'ROUGE EXCLUSIVE'
    };

    return resources[label];
}
